<div class="row animate fadeIn fast">
    <div class="col-4">
        <div class="card">
            <div class="card-body">
                <h3>Users</h3>

                <!-- ***Alerta -->
                <div class="alert alert-info" *ngIf="usuarios.length === 0">
                    <p class="mb-0">No Users</p>
                </div>



                <!-- ***Tabla de datos de Usuario -->
                <div class="table-responsive" *ngIf="usuarios.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Avatar</th>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="animated fadeIn fast" *ngFor="let usuario of usuarios">
                                <td>
                                    <img class="w50" [src]="usuario.img | imagen: 'users'" [alt]="usuario.name">
                                </td>
                                <td>
                                    <div class="row">
                                        <div class="col-12">{{usuario.name}}</div>
                                        <div class="col-12"><i>{{usuario.email}}</i></div>
                                    </div>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>



            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card">
            <div class="card-body">
                <h3>Employees</h3>

                <!-- ***Alerta -->
                <div class="alert alert-info" *ngIf="empleados.length === 0">
                    <p class="mb-0">No Employees</p>
                </div>



                <!-- ***Tabla de datos de Empleados -->
                <div class="table-responsive" *ngIf="empleados.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Photo</th>
                                <th>Name</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="animated fadeIn fast" *ngFor="let item of empleados">
                                <td>
                                    <img class="w50" [src]="item.img | imagen: 'empleados'" [alt]="item.name">
                                </td>
                                <td>
                                    <a [routerLink]="['/dashboard/employee', item._id]">
                                    {{item.name}}
                                  </a>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                </div>



            </div>
        </div>
    </div>
    <div class="col-4">
        <div class="card">
            <div class="card-body">
                <h3>Areas</h3>

                <!-- ***Alerta -->
                <div class="alert alert-info" *ngIf="areas.length === 0">
                    <p class="mb-0">No Areas</p>
                </div>



                <!-- ***Tabla de datos de Áreas -->
                <div class="table-responsive" *ngIf="areas.length > 0">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Image</th>
                                <th>Area</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="animated fadeIn fast" *ngFor="let item of areas">
                                <td>
                                    <img class="w50" [src]="item.img | imagen: 'areas'" [alt]="item.name">
                                </td>
                                <td>{{item.name}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>



            </div>
        </div>
    </div>
</div>